export const WorkPreview = {
  data() {
    return {
      workLists: ['All','Vue.js','Photoshop/Illustrator','Google Apps Script','Html/Css/Js'],
      preview: [],
      imgTitle: false,
      imgIndex: null
    }
  },
  methods: {
    mouseOverAction(index) {
      this.imgTitle = true
      this.imgIndex = index
    },
    mouseLemoveAction() {
      this.imgTitle = false
    },
  },
  watch: {
    preview() {
      var preview = this.preview;
      var workContents = this.workContents;

      if(preview.length > 0) {

        for(var i = 0; i < workContents.length; i++){
          var categories = workContents[i].categories;
          console.log("カテゴリの数");    

          for(var j = 0; j < preview.length; j++){
            console.log("previewの数");    
          
            if(categories.indexOf(preview) >= 0){          
              workContents[i].display = true;
              console.log("選択されたコンテンツを表示");    
              // workContents[i].display.style.pacity = 1;
                    
              break;

            } else {
              // workContents[i].display.style.pacity = 0;
              workContents[i].display = false;
            }
          }
        }
      }
    }
  }
}